import { FaAward } from "react-icons/fa"
import { TbBooks } from "react-icons/tb"
import { BiHappyHeartEyes } from "react-icons/bi"

const data = [
    { id: 1, icon: <FaAward />, title: 'Experience', desc: "A year working experience" },
    { id: 1, icon: <TbBooks />, title: 'Projects', desc: "10+ completed" },
    { id: 1, icon: <BiHappyHeartEyes />, title: 'Clients', desc: "5+ happy clients" }
]


export default data;